module.exports = __webpack_public_path__ + "static/L5Y0s-e769c4b7d4b3eab557ac41a0260cd267.jpg";